import React from "react";
import { NavLink } from "react-router-dom";
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";

// TRUN consultar con monca sobre llamadas a los importadores que estan relacionasdos con un RUN

const MenuImporters = ({ oetID, runID, status, run, oet, ...others }) => {
    return (
        <UncontrolledDropdown>
            {(status === 1 || status === 4 || status === 5) && [
                <DropdownToggle caret key="ipm_1">
                    Options
                </DropdownToggle>,
                <DropdownMenu right key="ipm_2">
                    {status === 1 && run.type_flow !== "sode_bulk" && (
                        <DropdownItem
                            tag={NavLink}
                            exact={true}
                            activeClassName="active"
                            to={`/site/importer/${oetID}/${runID}/`}
                        >
                            <span>Sites Importer</span>
                        </DropdownItem>
                    )}
                    {status === 1 && run.type_flow !== "sode_bulk" && <DropdownItem divider />}
                    {status === 1 && run.action !== "amend" && run.type_flow !== "sode_bulk" && (
                        <>
                            <DropdownItem
                                tag={NavLink}
                                activeClassName="active"
                                to={`/serviceorderitem/importer/${oetID}/${runID}/`}
                            >
                                <span>SSOT Importer</span>
                            </DropdownItem>

                            { oet.customer_team_is_active_for_ssot_web_form &&
                                <DropdownItem
                                    tag={NavLink}
                                    activeClassName="active"
                                    to={`/ssot-web-form/${oetID}/${runID}/`}
                                >
                                    <span>SSOT Web Form</span>
                                </DropdownItem>
                            }
                        </>
                    )}
                    {status === 1 && run.action !== "amend" && run.type_flow === "sode_bulk" && (
                        <DropdownItem
                            tag={NavLink}
                            activeClassName="active"
                            to={`/ssotbulk/importer/${oetID}/${runID}/`}
                        >
                            <span>SSOT Bulk Importer </span>
                        </DropdownItem>
                    )}
                    {status === 1 && run.action === "amend" && run.type_flow !== "sode_bulk" && (
                        <DropdownItem tag={NavLink} activeClassName="active" to={`/amend/importer/${oetID}/${runID}/`}>
                            <span>SSOT Importer </span>
                        </DropdownItem>
                    )}
                    {status === 1 && run.action === "amend" && run.type_flow === "sode_bulk" && (
                        <DropdownItem
                            tag={NavLink}
                            activeClassName="active"
                            to={`/ssotbulk/amend/importer/${oetID}/${runID}/`}
                        >
                            <span>SSOT Bulk Importer </span>
                        </DropdownItem>
                    )}
                    {status === 4 && run.type_flow !== "sode_bulk" && (
                        <DropdownItem
                            tag={NavLink}
                            activeClassName="active"
                            to={`/serviceorderitem/cpm/importer/${oetID}/${runID}/`}
                        >
                            <span>SSOT Importer CPM</span>
                        </DropdownItem>
                    )}
                    {status === 4 && run.type_flow === "sode_bulk" && (
                        <DropdownItem
                            tag={NavLink}
                            activeClassName="active"
                            to={`/ssotbulk/cpm/importer/${oetID}/${runID}/`}
                        >
                            <span>SSOT Bulk Importer CPM</span>
                        </DropdownItem>
                    )}
                    {status === 5 && (
                        <React.Fragment>
                            {run.type_flow !== "sode_bulk" && (
                                <DropdownItem
                                    tag={NavLink}
                                    activeClassName="active"
                                    to={`/serviceorderitemomc/omc/importer/${oetID}/${runID}/`}
                                >
                                    <span>SSOT Importer OMC</span>
                                </DropdownItem>
                            )}
                            {run.type_flow === "sode_bulk" && (
                                <DropdownItem
                                    tag={NavLink}
                                    activeClassName="active"
                                    to={`/ssotbulk/omc/importer/${oetID}/${runID}/`}
                                >
                                    <span>SSOT Importer OMC</span>
                                </DropdownItem>
                            )}
                            {run.type_flow !== "sode_bulk" && (
                                <DropdownItem
                                    tag={NavLink}
                                    activeClassName="active"
                                    to={`/siteomc/importer/omc/${oetID}/${runID}/`}
                                >
                                    <span>Site Importer OMC</span>
                                </DropdownItem>
                            )}
                            <DropdownItem tag={NavLink} activeClassName="active" to={`/pr-importer/${oetID}/${runID}/`}>
                                <span>PR importer</span>
                            </DropdownItem>
                            <DropdownItem
                                tag={NavLink}
                                activeClassName="active"
                                to={`/pr-omc-importer/${oetID}/${runID}/`}
                            >
                                <span>(PR) OET OMC Importer</span>
                            </DropdownItem>
                        </React.Fragment>
                    )}
                </DropdownMenu>
            ]}
        </UncontrolledDropdown>
    );
};
export default MenuImporters;
